<template>    
    <v-radio-group column :value="baseMapLayer.id">       
      <v-input class="radioinput" append-icon="mdi-information-variant" hide-details @click:append="showInfosTrad('OSM')">
        <v-radio @change="$store.myActions.UI_UNSELECT_MAP_BASELAYER(uiid)" value="OSM" label="Open Street Map" />      
      </v-input>
      <v-input class="radioinput" v-for="layer in baselayersmaps" :key="layer.id" :append-icon="hasConfig(layer)?'mdi-information-variant':''" hide-details @click:append="showInfos(layer)" >
        <v-radio @change="$store.myActions.UI_SELECT_MAP_BASELAYER({layer:layer,uiid})" :value="layer.id" :label="layerName(layer.libelle)" />        
      </v-input>      
    </v-radio-group>    
</template>
<script>
  
import { LayerSourceType } from '@/enum/LayerSourceType'
import { LayerConfig } from '@/models/ui/LayerConfig'
import { mapGetters } from 'vuex' 
  export default {    
    name: 'MapPanelBaseLayer',
    props:{
      uiid:{
          type: String,
          required: true,
          default: 'map_global'
      }
    },  
    data() {
      return {   
        test:false
      }
    },
   computed: {
       ...mapGetters([
        'uistatebyuiid'      
        ]),
        mapstate() { 
          //retourne un MapUiState
          return this.uistatebyuiid(this.uiid)          
        },
        baseMapLayer() {
          return this.mapstate.baseMapLayer
        },
        baselayersmaps(){
          return this.$store.myGetters.mapLayers.filter(l =>  l.LAY_SCOPE != "MIS"  &&  l.LAY_SCOPE != "MIG" 
                                                          && !!(JSON.parse((l.LAY_CONFIG_JSON?.length ?? 0 )>0?l.LAY_CONFIG_JSON:'{}').isBasic)
                                                        )          
        }

    },
    methods: {       
      showInfosTrad(id) { 
        this.$store.myActions.UI_SHOW_INFOS_DIALOG({
          title: this.$t(`Pilot.BaseLayer.${id}.Title`) + " " + this.$t('Pilot.BaseLayer.SourceInformation'),
          infos: this.$t(`Pilot.BaseLayer.${id}.Info`),
          urlinfos: this.$t(`Pilot.BaseLayer.${id}.UrlInfo`)
        })
      },
      getConfig(layer){
        return this.mapstate?.layermapconfig[layer.id] ?? new LayerConfig(JSON.parse((layer.LAY_CONFIG_JSON?.length ?? 0 )>0?layer.LAY_CONFIG_JSON:'{}'))
      },
      showInfos(layer) {
        const config = this.getConfig(layer)
        this.$store.myActions.UI_SHOW_INFOS_DIALOG({
          title: `${this.layerName(layer.libelle)} Source Information`,
          infos: `Credits : ${config.credit}<br/>Service : ${config.url}<br/>Layer : ${config.layer}`, 
          urlinfos: config.urlInfo
        })
      },
      hasConfig(layer) {        
        const config = this.getConfig(layer)
        return config.type != LayerSourceType.NONE
      },
      layerName(libelle) {
        return libelle?.split(':').pop().trim()
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

.radioinput .v-input__append-outer{
  flex: 1 1 auto;
}
</style>
